var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import NumberRange from "~/components/common/number-range.vue";
import ApplyFlow from "~/components/outsource-manage/recycle-manage/apply-flow.vue"; // 案件分配
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { OutsourceRecycleService } from "~/services/domain-service/outsource-recycle-manage.service";
import { CityService } from "~/utils/city.service";
import { CASE_CHANNEL, MENU_CHANNEL } from "~/config/enum.config";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
var RecycleManageIndex = /** @class */ (function (_super) {
    __extends(RecycleManageIndex, _super);
    function RecycleManageIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.caseChannel = CASE_CHANNEL.OUTER;
        _this.dialog = {
            applyFlow: false
        };
        _this.proinviceList = []; // 省
        _this.cityList = []; //市
        _this.queryModel = {
            outBatch: "",
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            localAddress: "",
            currentCollector: "",
            overduePeriod: "",
            turnSource: "",
            followupBack: "",
            productCategory: "",
            productName: "",
            followInTime: [],
            area: "",
            outAmount: {
                max: "",
                min: ""
            },
            caseMoney: { min: "", max: "" },
            overdueDays: {
                max: "",
                min: ""
            },
            labelName: []
        };
        _this.dataList = []; //数据列表
        _this.selectionList = []; //选中数据
        return _this;
    }
    RecycleManageIndex.prototype.mounted = function () {
        this.refreshData();
        this.getProvinces();
    };
    //获取省数据
    RecycleManageIndex.prototype.getProvinces = function () {
        this.proinviceList = CityService.getCityData({ level: 1 });
    };
    //获取市
    RecycleManageIndex.prototype.getCitys = function (provinceId) {
        if (this.queryModel.cityCode) {
            this.queryModel.cityCode = "";
        }
        this.cityList = this.$city.getCityData({ level: 1, id: provinceId }); // 城市列表
    };
    /**
     * 移入委外待分配
     */
    RecycleManageIndex.prototype.moveIntoAllocated = function () {
        var _this = this;
        if (this.selectionList.length === 0) {
            this.$message.info("请选择需要移入委外待分配的案件");
            return;
        }
        var temp = [];
        this.selectionList.map(function (value) {
            temp.push(value.id);
        });
        var query = {
            caseIds: temp
        };
        //移入委外待分配
        this.outsourceRecycleService.caseMoveAllocation(query).subscribe(function (data) {
            _this.refreshData();
            _this.$message.success("移入待分配案件成功!");
        });
    };
    /**
     * 申请流转
     */
    RecycleManageIndex.prototype.applyTurn = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择需要移入委外待分配的案件");
            return;
        }
        this.dialog.applyFlow = true;
    };
    RecycleManageIndex.prototype.refreshData = function () {
        var _this = this;
        //默认加载列表
        this.outsourceRecycleService
            .caseOutRecoveryList(this.queryModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataList = data;
            _this.selectionList = [];
        });
    };
    /**
     * 进入查看执行页
     */
    RecycleManageIndex.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Outsource_recover,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    /**
     * 重置numberRange
     */
    RecycleManageIndex.prototype.follFeedback = function () {
        this.queryModel.outAmount = { min: "", max: "" };
        this.queryModel.overdueDays = { min: "", max: "" };
        this.queryModel.proinviceCode = "";
        this.queryModel.cityCode = "";
        this.queryModel.caseMoney = { min: "", max: "" };
    };
    __decorate([
        Dependencies(OutsourceRecycleService)
    ], RecycleManageIndex.prototype, "outsourceRecycleService", void 0);
    __decorate([
        Dependencies(PageService)
    ], RecycleManageIndex.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], RecycleManageIndex.prototype, "sortService", void 0);
    RecycleManageIndex = __decorate([
        Auth(1006),
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                NumberRange: NumberRange,
                ApplyFlow: ApplyFlow
            }
        })
    ], RecycleManageIndex);
    return RecycleManageIndex;
}(Vue));
export default RecycleManageIndex;
